import { useWhenVisible } from '@emico-utils/when-visible'

import dataLayer, { GTMEvent } from './dataLayer'

const push = <T extends GTMEvent>(item: T) => {
  dataLayer.push(item)
}

const threshold = 0.5

const usePushWhenVisible = <T extends HTMLElement>(item: GTMEvent) =>
  useWhenVisible<T>(
    () => push(item),
    ({ isIntersecting, hasRunBefore }) => isIntersecting && !hasRunBefore,
    { threshold },
  )

export { usePushWhenVisible }

export default push
